import { IntegrationsStore } from '@/core/store/Integrations'
import { integrationsModule } from '@/core/modules/integrations/integrations.module'
import { usePendingProviders } from '@/core/hooks/usePendingProviders/usePendingProviders'

export const useFraudDefenseMarketing = () => {
    const microsoftProvider = IntegrationsStore.getProviderByType('microsoft')
    const googleProvider = IntegrationsStore.getProviderByType('google')
    const msFraudDefense =
        IntegrationsStore.getProviderByType('ms_fraud_defense')
    const googleFraudDefense = IntegrationsStore.getProviderByType(
        'google_fraud_defense'
    )

    const { isMicrosoftFraudDefenseLoading, isGoogleFraudDefenseLoading } =
        usePendingProviders()

    const msActiveIntegrations =
        IntegrationsStore.getActiveAndBrokenIntegrationsByType('microsoft')
    const googleActiveIntegrations =
        IntegrationsStore.getActiveAndBrokenIntegrationsByType('google')

    const shouldShowMsUpdateBanner = msActiveIntegrations.length > 0
    const shouldShowGoogleUpdateBanner = googleActiveIntegrations.length > 0
    const shouldShowMarketingPage =
        !shouldShowMsUpdateBanner && !shouldShowGoogleUpdateBanner

    const handleMicrosoftIntegrationClick = () => {
        if (msFraudDefense) {
            integrationsModule.handleIntegrationLogin({
                providerId: msFraudDefense.id,
                type: msFraudDefense.type,
                origin: 'fraud-defense-page',
                action: 'add',
            })
        }
    }

    const handleGoogleIntegrationClick = () => {
        if (googleFraudDefense) {
            integrationsModule.handleIntegrationLogin({
                providerId: googleFraudDefense.id,
                type: googleFraudDefense.type,
                origin: 'fraud-defense-page',
                action: 'add',
            })
        }
    }

    const handleMsUpdateClick = () => {
        if (msFraudDefense) {
            integrationsModule.handleIntegrationLogin({
                providerId: msFraudDefense.id,
                type: msFraudDefense.type,
                origin: 'fraud-defense-page',
                action: 'update',
            })
        }
    }

    const handleGoogleUpdateClick = () => {
        if (googleFraudDefense) {
            integrationsModule.handleIntegrationLogin({
                providerId: googleFraudDefense.id,
                type: googleFraudDefense.type,
                origin: 'fraud-defense-page',
                action: 'update',
            })
        }
    }

    return {
        handleMicrosoftIntegrationClick,
        handleGoogleIntegrationClick,
        handleMsUpdateClick,
        handleGoogleUpdateClick,
        googleProvider,
        microsoftProvider,
        shouldShowMsUpdateBanner,
        shouldShowGoogleUpdateBanner,
        shouldShowMarketingPage,
        isMicrosoftFraudDefenseLoading,
        isGoogleFraudDefenseLoading,
    }
}
